const keyMirror = require('key-mirror');

export default keyMirror({
  USER_AUTHORIZATION_REQUESTED: null,
  USER_AUTHORIZED_SUCCESSFUL: null,
  USER_AUTHORIZATION_ERROR: null,
  
  USER_LOGGED_OUT: null,

  USER_REGISTRATION_REQUESTED: null,
  USER_REGISTERED_SUCCESSFUL: null,
  USER_REGISTRATION_ERROR: null,
});



// WEBPACK FOOTER //
// ./src/shared/actions/actions.js